import React from "react";

import Ec2InfraTypeSwitch from "./Ec2InfraTypeSwitch";

function IndexOfEc2Config() {
  return (
    <div>
      <Ec2InfraTypeSwitch />
    </div>
  );
}

export default IndexOfEc2Config;
